export const BUTTON_NAME = "Apply Filter"
